export class HibernateData {
  date: string;
  reason: string;
}
